import { useEffect, useRef, useState } from 'react';
import { Music, VolumeX } from 'lucide-react';

const P = process.env.PUBLIC_URL || '';
const EVENTS = ['pointerdown', 'touchstart', 'click', 'keydown'];

export default function MusicToggle() {
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    const a = new Audio(`${P}/music/wedding-song.mp3`);
    a.loop = true;
    a.preload = 'auto';
    a.load();
    audioRef.current = a;

    const play = () =>
      a
        .play()
        .then(() => setPlaying(true))
        .catch(() => setPlaying(false));

    play();

    const unlock = () => {
      a.play()
        .then(() => {
          setPlaying(true);
          EVENTS.forEach((ev) => document.removeEventListener(ev, unlock));
        })
        .catch(() => {});
    };
    EVENTS.forEach((ev) => document.addEventListener(ev, unlock));
    return () => {
      EVENTS.forEach((ev) => document.removeEventListener(ev, unlock));
      a.pause();
    };
  }, []);

  const toggle = () => {
    const a = audioRef.current;
    if (!a) return;
    if (playing) {
      a.pause();
      setPlaying(false);
    } else {
      a.play()
        .then(() => setPlaying(true))
        .catch(() => {});
    }
  };

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={playing ? 'Mute music' : 'Play music'}
      data-testid="music-toggle"
      className="fixed bottom-5 right-5 z-50 flex h-12 w-12 items-center justify-center rounded-full border border-kula-gold/50 bg-kula-deep text-kula-goldsoft shadow-xl transition-transform hover:scale-105 active:scale-95"
    >
      {playing && (
        <span className="absolute inset-0 rounded-full border border-kula-goldsoft/60 animate-ping" />
      )}
      {playing ? <VolumeX size={19} /> : <Music size={19} />}
    </button>
  );
}
